import axios from "axios";
import { GalaxyApi } from "@/api";
import { withPrefix } from "@/utils/redirect";
import { rethrowSimple } from "@/utils/simple-error";
export async function fetchDatasetDetails(params) {
    const { data, error } = await GalaxyApi().GET("/api/datasets/{dataset_id}", {
        params: {
            path: {
                dataset_id: params.id,
            },
            query: { view: "detailed" },
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
export async function undeleteDataset(datasetId) {
    const { data, error } = await GalaxyApi().PUT("/api/datasets/{dataset_id}", {
        params: {
            path: { dataset_id: datasetId },
        },
        body: {
            deleted: false,
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
export async function purgeDataset(datasetId) {
    const { data, error } = await GalaxyApi().DELETE("/api/datasets/{dataset_id}", {
        params: {
            path: { dataset_id: datasetId },
            query: { purge: true },
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
export async function copyDataset(datasetId, historyId, type = "dataset", source = "hda") {
    const { data, error } = await GalaxyApi().POST("/api/histories/{history_id}/contents/{type}s", {
        params: {
            path: { history_id: historyId, type },
        },
        body: {
            source,
            content: datasetId,
            // TODO: Investigate. These should be optional, but the API requires explicit null values?
            type,
            copy_elements: null,
            hide_source_items: null,
            instance_type: null,
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
export function getCompositeDatasetLink(historyDatasetId, path) {
    return withPrefix(`/api/datasets/${historyDatasetId}/display?filename=${path}`);
}
export async function fetchDatasetAttributes(datasetId) {
    const { data } = await axios.get(withPrefix(`/dataset/get_edit?dataset_id=${datasetId}`));
    return data;
}
